// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Lk-z","title":"Mk-z","nav":"Nk-z","flexCell":"Ok-z","facetLink":"Pk-z"};